import { call, put, takeEvery } from "redux-saga/effects";
import axios from "axios";
import { FETCH_ANEES_VOUCHERS_DATA } from "./actionTypes";
import {
  fetchAneesVouchersSuccess,
  fetchAneesVouchersFailure,
} from "./actions";

function* fetchAneesVouchersDataSaga() {
  try {
    const token = localStorage.getItem("authToken");
    const response = yield call(axios.get, process.env.REACT_APP_WEB_APP_URL + "/api/web/anees-vouchers",{
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
    yield put(fetchAneesVouchersSuccess(response.data));
  } catch (error) {
    yield put(fetchAneesVouchersFailure(error.message));
  }
}

export default function* AneesVouchersSaga() {
  yield takeEvery(FETCH_ANEES_VOUCHERS_DATA, fetchAneesVouchersDataSaga);
}
